import { FilterChip } from './components/FilterChip';
import { FilterComponentSelector } from './components/FilterComponentSelector';
import { FiltersState } from './getInitialFilter';
import { FilterColDef, FilterContext } from './types';

type Props = {
  filters: FiltersState;
  applyFilter: (filterContext: FilterContext, column: FilterColDef) => void;
  removeFilter: (field: string) => void;
  hideQueueChip: boolean;
};

export const FilterChips = ({
  filters,
  applyFilter,
  removeFilter,
  hideQueueChip,
}: Props) => {
  return (
    <>
      {Object.values(filters)
        .filter(f => (hideQueueChip ? f.column.field !== 'queue' : true))
        .map(filter => {
          const { column, isValid } = filter;

          return (
            <FilterChip
              key={column.field}
              onRemove={() => removeFilter(column.field)}
              incomingFilterItem={filter}
            >
              {({
                onClose,
                onOperatorChange,
                convertToAdvancedFilter,
                filterItem,
              }) => {
                return isValid ? (
                  <FilterComponentSelector
                    applyFilter={filterContext => {
                      applyFilter(filterContext, column);
                      onClose();
                    }}
                    onClose={onClose}
                    filterItem={filterItem}
                    onOperatorChange={onOperatorChange}
                    convertToAdvancedFilter={convertToAdvancedFilter}
                  />
                ) : null;
              }}
            </FilterChip>
          );
        })}
    </>
  );
};
